
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { CatalogoResponse } from "@/models/CatalogoResponse";
import AfiliadoService from "../services/AfiliadoService";
import Banco from "@/models/Banco";
import FormaDePago from "@/models/FormaDePago";
import { Getter } from "vuex-class";
import User from "@/models/User";
import CustomFileInput from "@/components/CustomFileInput.vue";
import Swal from "sweetalert2";
import Inputmask from "inputmask";

import { extend } from "vee-validate";
import Benefactor from "@/models/Sobrevivencia/Benefactor";
import FileConfig from "@/FileConfig";
import DocumentoPresolicitud from "@/models/DocumentoPresolicitud";
import BenefactorDocument from "@/models/Sobrevivencia/BenefactorDocument";

import CodTipoDocumento from "@/enums/CodTipoDocumento";
import TipoBeneficioEnum from "@/enums/TipoBeneficioEnum";

import RegistroPresolicitud from "@/models/RegistroPresolicitud";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import { PossibleStates } from "@/enums/PossibleStates";
import BaseSobrevivenciaRequest from "@/models/Sobrevivencia/BaseSobrevivenciaRequest";
import { sanitizeFileName } from "@/utils/SanitizeFileName";
import EmailValidator from "@/utils/EmailValidator";
Vue.directive("input-mask", {
  inserted(el, binding) {
    if (binding.value) {
      const im = new Inputmask(binding.value, {
        clearIncomplete: true, // Mejora el input en móviles
        showMaskOnHover: false,
        showMaskOnFocus: true,
        androidHack: true, // 👈 IMPORTANTE para Android
      });
      im.mask(el);
    }
  },
  update(el, binding) {
    if (binding.value) {
      const im = new Inputmask(binding.value, {
        clearIncomplete: true,
        showMaskOnHover: false,
        showMaskOnFocus: true,
        androidHack: true,
      });
      im.mask(el);
    }
  },
});

extend("mask", {
  validate: (value: string, params) => {
    var inputContains_ = value.indexOf("_") > -1;
    return !inputContains_;
  },
  params: [{ name: "mask" }],
  message: "El número de cuenta es inválido.",
});

class FormWizardStep {
  public tabIndex: number;
  public formWizardChildrenIndex: number;
}

@Component({ components: { CustomFileInput } })
export default class SeleccionMetodoPago extends Vue {
  // @Prop() benefactor: Benefactor;
  @Prop() estadoAseguradora: string;
  @Getter("currentBenefactor") benefactor: Benefactor;
  public referenciaBancaria: BenefactorDocument = new BenefactorDocument();
  public sobrevivenciaService: SobrevivenciaService =
    new SobrevivenciaService();
  public previousReferenciaDocumentoBancarioFiles: Array<DocumentoPresolicitud> =
    [];
  public referenciaBancariaValid: boolean = false;
  public inputReferenciaDocumentoBancarioIsValid: boolean = false;
  public triggerInputValidations = false;
  public referenciaDocumentoBancarioServerValidationMessage: string = "";
  public referenciaDocumentoBancarioFilesRequiredMessage: string =
    "La referencia de documento bancario es requerida.";
  public afiliadoService: AfiliadoService = new AfiliadoService();

  //#region Select Vias Notificacion
  public viasNotificacion: Array<CatalogoResponse> = [];
  public viasNotificacionLoading: boolean = false;
  public viaNotificacion: CatalogoResponse = null;
  //#endregion
  //#region Metodo de Pago
  public metodosDePago: Array<FormaDePago> = [];
  public metodosDePagoLoading: boolean = false;
  public metodoDePago: FormaDePago = null;
  //#endregion
  //#region Banco
  public bancos: Array<Banco> = [];
  public bancosLoading: boolean = false;
  public banco: Banco = null;
  //#endregion
  //#region Tipo de Cuenta
  public tiposDeCuenta: Array<CatalogoResponse> = [];
  public tiposDeCuentaLoading: boolean = false;
  public tipoDeCuenta: CatalogoResponse = null;
  //#endregion
  public numeroCuenta: string = null;
  @Getter("user") user: User;

  public modificaValorViaNotificacion: boolean = false;
  public valorViaNotificacion: string = null;
  public currentEmail: string = null;
  public currentTel: string = null;
  public fileConfig: FileConfig;
  public montoBeneficiario?: number;
  public isBenefactorEmailValid: boolean = true;

  public created() {
    this.fileConfig = new FileConfig(5, [
      "image/jpeg",
      "image/jpg",
      "image/tiff",
      "image/png",
      "application/pdf",
    ]);
  }

  get isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  public async mounted() {
    //OJO Promise ALL here
    this.getMontosBeneficiarios()
      .then(async (data) => {
        await this.getMetodosDePago();
      })
      .catch((x) => {});
    await this.getViasNotificacion();
    await this.getBancos();
    await this.getTiposDeCuenta();

    console.log("A1");
    this.getReferenciaBancaria();
    console.log("A2");
    this.setFieldValues();
    console.log("A3");
    this.setCurrentNotificacion();
    this.isReferenciaBancariaValid();

    Swal.close();
  }

  @Watch("metodoDePago")
  public MetodoPagoSelected(newValue: FormaDePago, oldValue: FormaDePago) {
    console.log(newValue);
    this.isReferenciaBancariaValid();
    if (newValue != null && newValue.formaPago != null) {
      this.benefactor.indFormaPago = newValue.formaPago;
    }
    this.benefactor.codEtapa = 7;
    if (oldValue.formaPago == "T") {
      this.banco = null;
      this.tipoDeCuenta = null;
      this.numeroCuenta = null;
      this.benefactor.codBanco = null;
      this.benefactor.numeroCuenta = null;
      this.benefactor.indTipoCuenta = null;

      this.resetReferenciaOnDb();
    }
  }

  @Watch("benefactor", { immediate: true, deep: true })
  public benefactoChanged(newValue: Benefactor, oldValue: Benefactor) {
    console.log(
      "benefactor  has been updated in seleccion metodo paog ",
      newValue
    );
    this.$store.dispatch("setCurrentBenefactor", newValue);
  }

  @Watch("banco")
  public onBancoSelected(newValue: Banco, oldValue: Banco): void {
    if (!!oldValue) {
      const numeroCuentaInput: HTMLInputElement = this.$refs
        .numeroCuenta as HTMLInputElement;
      if (numeroCuentaInput) {
        numeroCuentaInput.value = "";
      }
      this.numeroCuenta = "";
    }

    this.benefactor.codBanco = newValue.codigoBanco;
  }

  @Watch("tipoDeCuenta")
  public handleSelectedTipoCuenta(
    newValue: CatalogoResponse,
    oldValue: CatalogoResponse
  ) {
    this.benefactor.indTipoCuenta = newValue.value;
  }

  @Watch("numeroCuenta")
  public handleSelectedNumeroCuenta(newValue: string, oldValue: string) {
    this.benefactor.numeroCuenta = newValue;
  }

  @Watch("viaNotificacion")
  public handleSelectedViaNotificacion(
    newValue: CatalogoResponse,
    oldValue: CatalogoResponse
  ) {
    this.benefactor.tipoNotificacion = newValue.value;
  }

  //   @Watch("valorViaNotificacion")
  //   public handleValorViaNotificacion(newValue: string, oldValue: string) {
  //     if (this.benefactor.tipoNotificacion == "E") {
  //         const error = EmailValidator.validate(newValue);
  // if (error) {
  //       this.isBenefactorEmailValid = false;
  //     }
  //       this.isBenefactorEmailValid = true;

  //       return (this.benefactor.email = newValue);
  //     }

  //     this.benefactor.numTelef = newValue;
  //   }

  @Watch("valorViaNotificacion")
  public handleValorViaNotificacion(newValue: string, oldValue: string) {
    if (this.benefactor.tipoNotificacion == "E") {
      // const error = EmailValidator.validate(newValue);
      // if (error) {
      //   this.isBenefactorEmailValid = false;
      // }
      // this.isBenefactorEmailValid = true;
      return (this.benefactor.email = newValue.trim().toLowerCase() || null);
    }

    this.benefactor.numTelef = newValue;
  }

  @Watch("benefactor.documents", { immediate: true })
  public benefactotDocumentsWatch(newValue) {
    console.log("documentosss value new", newValue);
  }

  // @Watch("benefactor",{deep:true  })
  public setRefernciaBancariaDocument(
    newValue: Benefactor,
    oldValue: Benefactor
  ) {
    try {
      // console.log("benefactor before changed", newValue)
      //  console.log("benefactor before changed documents", newValue.documents)
      //  const copia:Benefactor = {...newValue};
      //  console.log(copia)
      // let lala = this.benefactor?.documents?.find( (document) =>
      // document.idBeneficiario!=null )
      // console.log("benefactor changed", lala)
      // this.referenciaBancaria = newValue?.documents?.find( (document) =>
      // document.codTipDocumento == CodTipoDocumento.ComprobanteDeCuenta )

      this.referenciaBancaria = this.getDocumentos;
    } catch (e) {
      console.log("error", e);
    }

    //  let documentoPresolicitud :DocumentoPresolicitud = new DocumentoPresolicitud(
    //  this.benefactor.numPreSolicitud,
    //  this.referenciaBancaria.seqDocumento,
    //  this.referenciaBancaria.codTipDocumento.toString(),
    //  this.referenciaBancaria.link,
    //  true,
    //  false,
    //  null,
    //  null,

    //  );
  }

  public showLoadingAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
    });
  }

  public showLoadingConfirm(message: string, onClose: () => void = () => {}) {
    Swal.fire({
      text: message,
      icon: "info",
      timerProgressBar: true,
      allowOutsideClick: false,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      onClose,
    });
  }

  public showErrorAlert(
    message: string,
    allowOutsideClick: boolean = true
  ): void {
    Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: allowOutsideClick,
      confirmButtonText: "Ok",
      allowOutsideClick,
    });
  }
  public showErrorAlertAndRedirect(
    message: string,
    allowOutsideClick: boolean = false
  ): void {
    Swal.fire({
      text: message,
      icon: "error",
      showConfirmButton: true,
      confirmButtonText: "Ok",
      allowOutsideClick,
    }).then((resp) => {
      if (resp) {
        this.$router.push("/home");
      }
    });
  }

  public showInfoAlert(message: string): void {
    Swal.fire({
      text: message,
      icon: "info",
    });
  }

  get valorViaNotificacionActual(): string {
    if (this.viaNotificacion) {
      switch (this.viaNotificacion.value) {
        case "E":
          return this.currentEmail;
        case "C":
          return this.currentTel;
        default:
          return;
      }
    } else {
      return null;
    }
  }

  get inputNumeroCuentaRules() {
    if (!this.banco) {
      return "";
    }

    if (!this.banco.validaMascara) {
      var mask = "";

      for (let i = 0; i < this.banco.lenMinimaCuenta; i++) {
        mask = mask + "9";
      }
      for (
        let i = 0;
        i < this.banco.lenMaximaCuenta - this.banco.lenMinimaCuenta;
        i++
      ) {
        mask = mask + "[9]";
      }
      this.banco.mascaraCuenta = mask;

      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return (
        "required|mymin-validation:" +
        String(this.banco.lenMinimaCuenta) +
        "|mymax-validation:" +
        String(this.banco.lenMaximaCuenta) +
        "|mask:" +
        String(mask)
      );
    } else {
      var mask = this.banco ? String(this.banco.mascaraCuenta) : "";
      return "required|mask:" + String(this.banco.mascaraCuenta);
    }
  }
  public convertirMascaraARegex(mascara) {
    let regex = "^";

    for (let char of mascara) {
      if (char === "9") {
        regex += "\\d";
      } else if (char === "[") {
        regex += "\\d?";
      } else if (char === "]") {
        continue;
      } else {
        regex += "\\" + char;
      }
    }

    regex += "$";
    return regex;
  }
  public async getViasNotificacion(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.viasNotificacionLoading = true;
    const response = await this.afiliadoService.viasNotificacion(term);
    if (response.data.entity) {
      this.viasNotificacion = response.data.entity;
    } else {
      this.viasNotificacion = [];
    }
    this.viasNotificacionLoading = false;
  }

  public async getBancos(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.bancosLoading = true;
    const response = await this.afiliadoService.bancos(term);
    if (response.data.entities) {
      this.bancos = response.data.entities;
    } else {
      this.bancos = [];
    }
    this.bancosLoading = false;
  }

  public async getMetodosDePago(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.metodosDePagoLoading = true;
    const response = await this.afiliadoService.metodosDePagoSobrevivencia(
      this.montoBeneficiario,
      "2",
      this.estadoAseguradora,
      term
    );
    if (response.data.entities) {
      this.metodosDePago = response.data.entities;
    } else {
      this.metodosDePago = [];
    }
    this.metodosDePagoLoading = false;
  }

  public async getTiposDeCuenta(term: string = null) {
    if (term && term.length <= 3) {
      return;
    }

    this.tiposDeCuentaLoading = true;
    const response = await this.afiliadoService.tiposDeCuenta(term);
    if (response.data.entity) {
      this.tiposDeCuenta = response.data.entity;
    } else {
      this.tiposDeCuenta = [];
    }
    this.tiposDeCuentaLoading = false;
  }

  get metodoDePagoIsTransferenciaBancaria(): boolean {
    return this.metodoDePago && this.metodoDePago.formaPago === "T";
  }

  public setFieldValues(): void {
    // if (this.previousDocumentoFiles && this.previousDocumentoFiles.length > 0) {
    //   this.tipoDocumento = this.tiposDocumento.find(
    //     (x) =>
    //       x.codRequisito ===
    //       Number(this.previousDocumentoFiles[0].tipoDocumento)
    //   );
    // }
    console.log(
      "setting Values : ",
      this.metodosDePago,
      this.bancos,
      this.tiposDeCuenta,
      this.viasNotificacion,
      this.benefactor
    );
    this.metodoDePago = this.metodosDePago.find(
      (x) => x.formaPago === this.benefactor.indFormaPago
    );
    this.banco = this.bancos.find(
      (x) => x.codigoBanco === String(this.benefactor.codBanco)
    );
    this.tipoDeCuenta = this.tiposDeCuenta.find(
      (x) => x.value === this.benefactor.indTipoCuenta
    );
    this.numeroCuenta = this.benefactor.numeroCuenta;
    this.viaNotificacion = this.viasNotificacion.find(
      (x) => x.value === this.benefactor.tipoNotificacion
    );
  }

  get existPreviousReferenciaDocumentoBancarioFiles() {
    if (
      this.referenciaBancaria == null ||
      this.referenciaBancaria.link == null ||
      this.referenciaBancaria.link.length <= 0
    )
      return false;
    return true;
  }

  get previousReferenciaDocumentoBancarioRequiereCambioDoc() {
    return this.referenciaBancaria?.estRecepDoc == PossibleStates.Rechazado;
    return true;
  }
  get fileInputRefDocumentoBancarioEsRequerido() {
    return this.metodoDePago?.formaPago == "T";
  }

  public async onAddOrRemoveReferenciaDocumentoBancarioFile(
    files: Array<File>
  ): Promise<void> {
    this.triggerInputValidations = !this.triggerInputValidations;

    if (files?.length > 0) {
      this.referenciaBancariaValid = true;
      const sanitizedFiles = files.map((file) => {
        const cleanName = sanitizeFileName(file.name);
        return new File([file], cleanName, {
          type: file.type,
          lastModified: file.lastModified,
        });
      });
      let document = this.referenciaBancaria;
      document.files = sanitizedFiles;

      const anyFileTypeInvalid: boolean = document.files.some(
        (x) => !this.fileConfig.allowedFileTypes.includes(x.type)
      );

      const anyFileSizeInvalid: boolean = document.files.some(
        (x) => x.size / 1000000 > this.fileConfig.fileSizeMbLimit
      );

      if (anyFileSizeInvalid || anyFileTypeInvalid) {
        this.referenciaBancariaValid = false;
      }

      if (!anyFileSizeInvalid && !anyFileTypeInvalid) {
        const response = await this.uploadFile(document);

        if (response.data.respCode == 200) {
          document.observaciones = null;

          await this.sobrevivenciaService.GuardarDocumentacion(
            "PortalBe",
            "0092873730",
            document.files.map((file, index) => ({
              ...(this.benefactor
                ? { idBeneficiario: this.benefactor.idBeneficiario }
                : {}),
              link: response.data.entity[index],
              numPreSolicitud: document.numPreSolicitud,
              seqDocumento: document.seqDocumento,
            }))
          );

          this.$emit("documentoActualizado");
        }
      }
    } else {
      this.referenciaBancariaValid = false;
      let document = this.referenciaBancaria;
      document.observaciones = null;

      await this.sobrevivenciaService.GuardarDocumentacion(
        "PortalBe",
        "0092873730",
        document.files.map((file, index) => ({
          ...(this.benefactor
            ? { idBeneficiario: this.benefactor.idBeneficiario }
            : {}),
          link: "",
          numPreSolicitud: document.numPreSolicitud,
          seqDocumento: document.seqDocumento,
        }))
      );

      this.$emit("documentoActualizado");
    }
  }

  public referenciaDocumentoBancarioValidationChanged(isValid: boolean): void {
    this.inputReferenciaDocumentoBancarioIsValid = isValid;
  }

  public isReferenciaBancariaValid() {
    console.log(
      "isReferenciaBancariaValid",
      this.metodoDePago,
      this.referenciaBancaria
    );
    if (
      this.metodoDePago.formaPago == "G" ||
      this.metodoDePago.formaPago == "C"
    ) {
      this.referenciaBancariaValid = true;
    } else if (this.metodoDePago.formaPago == "T") {
      if (
        this.referenciaBancaria != null &&
        this.referenciaBancaria.link != null &&
        this.referenciaBancaria.link.length > 0
      ) {
        this.referenciaBancariaValid = true;
      } else {
        this.referenciaBancariaValid = false;
      }
    }
    console.log("is referencia bancaria valid done");
  }

  get isTransferencia() {
    return this.metodoDePago?.formaPago == "T";
  }

  public async uploadFile(document: BenefactorDocument) {
    const registroPresolicitud = new RegistroPresolicitud();
    registroPresolicitud.presolicitud.tipoBeneficio =
      TipoBeneficioEnum.Fallecimiento.toString();
    registroPresolicitud.presolicitud.estado = "C";

    let numeroSolicitud: string | null = null;

    if (this.$route.query.params) {
      let paramsecript = this.$route.query.params.toString();
      paramsecript = paramsecript.replace(/\s/g, "+");
      const decrypt = this.afiliadoService.decryptByDES(paramsecript);
      try {
        const decryptedObj = JSON.parse(decrypt);
        if (decryptedObj && decryptedObj.numPreSolicitud) {
          numeroSolicitud = decryptedObj.numPreSolicitud.toString();
        }
      } catch (error) {
        console.error("Error parsing decrypted params:", error);
      }
    }

    if (!numeroSolicitud) {
      const params = new URLSearchParams(window.location.search);
      numeroSolicitud = params.get("numeroSolicitud");
    }

    if (!numeroSolicitud) {
      throw new Error("Número de solicitud faltante");
    }

    const numeroSolicitudInt = parseInt(numeroSolicitud);
    if (isNaN(numeroSolicitudInt)) {
      throw new Error("Número de solicitud inválido");
    }

    registroPresolicitud.presolicitud.numeroSolicitud = numeroSolicitudInt;

    document.files.forEach((file) =>
      registroPresolicitud.tiposDocumento.push(file.type)
    );

    const files = { [document.codigoRuta]: document.files };

    const response = await this.callUpload(registroPresolicitud, files);

    return response;
  }

  public async callUpload(
    registroPresolicitud: RegistroPresolicitud,
    files: {
      [key: string]: File[];
    }
  ) {
    const response = await this.sobrevivenciaService.uploadDocumentation(
      registroPresolicitud,
      files
    );
    return response;
  }

  get getDocumentos() {
    return this.benefactor?.documents?.find(
      (document) =>
        document.codTipDocumento == CodTipoDocumento.ComprobanteDeCuenta
    );
  }

  public getReferenciaBancaria() {
    this.referenciaBancaria = this.benefactor?.documents?.find(
      (document) =>
        document.codTipDocumento == CodTipoDocumento.ComprobanteDeCuenta
    );
    if (this.referenciaBancaria != null) {
      let documentoPresolicitud: DocumentoPresolicitud =
        new DocumentoPresolicitud(
          this.benefactor.numPreSolicitud,
          this.referenciaBancaria.seqDocumento,
          this.referenciaBancaria.codTipDocumento.toString(),
          this.referenciaBancaria.link,
          true,
          false,
          null,
          null
        );
      console.log(documentoPresolicitud);
      this.previousReferenciaDocumentoBancarioFiles.push(documentoPresolicitud);
    }
  }

  public getFileName(fileUrl: string): string {
    if (fileUrl.includes("/")) {
      const fileName = fileUrl.split("/");
      return fileName[fileName.length - 1];
    } else {
      return fileUrl;
    }
  }

  public async resetReferenciaOnDb() {
    let document = this.referenciaBancaria;
    await this.sobrevivenciaService.GuardarDocumentacion(
      "PortalBe",
      "0092873730",
      [
        {
          link: "",
          numPreSolicitud: this.benefactor.numPreSolicitud,
          seqDocumento: CodTipoDocumento.ComprobanteDeCuenta,
        },
      ]
    );
  }

  public setCurrentNotificacion() {
    this.currentEmail = this.benefactor.email;
    this.currentTel = this.benefactor.celular;
  }

  public onRemoveReferenciaDocumentoBancarioFile() {
    this.inputReferenciaDocumentoBancarioIsValid = false;
    this.referenciaBancariaValid = false;
    this.referenciaBancaria.link = null;
    this.resetReferenciaOnDb();
    // this.referenciaBancaria = this.benefactor?.documents?.find( (document) =>
    //   document.codTipDocumento == CodTipoDocumento.ComprobanteDeCuenta )
  }

  public async getMontosBeneficiarios() {
    console.log("ID BENEFICIAROO:", this.benefactor.idBeneficiario);
    return new Promise(async (resolve, reject) => {
      let request = new BaseSobrevivenciaRequest(
        "PortalBe",
        "0092873730",
        this.benefactor.numPreSolicitud
      );
      let responseBalance =
        await this.sobrevivenciaService.getDistribucionBalance(request);
      console.log("Response Monto", responseBalance);

      if (responseBalance.data == null || responseBalance.status != 200) {
        reject();
      }
      let montoBeneficiario = responseBalance.data.data.find(
        (x) => x.idBeneficiario == this.benefactor.idBeneficiario
      )?.montoFiltrarMpago;

      if (montoBeneficiario) {
        this.montoBeneficiario = montoBeneficiario;
        resolve(montoBeneficiario);
      }
      reject();
    });
  }

  @Watch("estadoAseguradora")
  public estadoWatch(newv, old) {
    this.getMetodosDePago();
  }
}
